import styled from '@emotion/styled';

export const SubscriptionHeaderTitle = styled.p`
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  color: ${({ theme }) => theme.color.content12};
  margin: 0;
`;
